import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAppDispatch } from 'store';

import { $apiV2, errorHandler } from 'modules/global';

import { setLessonStatus } from '../store';
import { lessonConst } from '..';

export const useFinishLessonTest = (slug?: string) => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ticketId?: number) => {
      const { data } = await $apiV2.post(`/check-test/finish?ticket_id=${ticketId}`);

      return data;
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: [lessonConst.queryKeys.LESSONS_RESULT, slug] });

      dispatch(setLessonStatus(lessonConst.LessonStatus.RESOLVED));
    },
    onError: errorHandler()
  });
};
